import { Chart as ChartJs, LineProps, Filler, CategoryScale, Tooltip, LinearScale , PointElement, LineElement } from 'chart.js';
import React from "react";
import { Line, Chart } from "react-chartjs-2";
import { commarize } from '../../helper';
ChartJs.register(CategoryScale, LinearScale, Filler, Tooltip, PointElement, LineElement);


export const VLineChart = (props) => {
  const labels = props.labels || [];
  const records = props.records || [];
  const dollar = props.dollar === true  ? '$' : '';

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: false, // Hide legend
      tooltip: {
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
          usePointStyle: true,
          beforeBody: function (context) {
            if (dollar) {
              return dollar + commarize(context[0].raw);
            } else {
              return context[0].raw;
            }
          },
          label : function (c) {
            return '';
          },
          labelColor: function(context) {
              return {
                  borderColor: 'rgb(0, 0, 255)',
                  backgroundColor: '#aaa',
                  borderWidth: 0,
                  borderDash: [2, 2],
                  borderRadius: 0,
              };
          },
          labelTextColor: function(context) {
              return '#aaa';
          }
        }
      }
    },
    scales: {
      x: {
        border: {
          display: false
        },
        ticks: {
          display: false
        },
      },
      y: {
          display: false,
          gridLines: {
              display: false
          },
          ticks: {
              display: true
          },
      },
    }
  };

  const data = {
    labels: labels,
    datasets: [
      {
        fill: true,
        backgroundColor: '#f19c39',
        lineTension: 0.2,
        borderColor: "#F8931F",
        borderDashOffset: 0.0,
        pointBorderColor: "#F8931F",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        borderWidth: 0,
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#F8931F",
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: records
      }
    ]
  };

  return (
    <div className='h-[450px]'>
        <Chart type='linewithline' data={data} options={options} />
    </div>
    );
}